import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';
import { AccountType, AccountStatus } from '../../types';

export const FilterFormComponent = () => {
    const accountTypeOptions = [
        { value: '', label: 'All Types' },
        { value: AccountType.STANDALONE, label: 'Standalone' },
        { value: AccountType.ROOT, label: 'Root' },
        { value: AccountType.MANAGED, label: 'Managed' },
    ];

    const accountStatusOptions = [
        { value: '', label: 'All Statuses' },
        { value: AccountStatus.ACTIVE, label: 'Active' },
        { value: AccountStatus.SUSPENDED, label: 'Suspended' },
        // FNP-383: surface soft-deleted accounts so admins can find and Restore them.
        { value: AccountStatus.PENDING_DELETION, label: 'Pending Deletion' },
    ];

    return (
        <>
            <Field
                name="accountType"
                label="Account Type"
                data={accountTypeOptions}
                component={FormikRadioGroup}
                my="md"
            />

            <Field
                name="accountStatus"
                label="Account Status"
                data={accountStatusOptions}
                component={FormikRadioGroup}
                my="md"
            />
        </>
    );
};